import React from 'react'
import { Spin, Typography } from 'antd'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { A4_PORTRAIT } from 'src/views/Management/Reports/types'
import { ApplicationState } from 'src/store'

import * as CSS from './styles'

import { OptionsBar, TitleReport } from '..'
import * as CSSPage from '../../styles'

const format = 'DD/MM/YYYY'

export default function R11() {
  const {
    reports: {
      reportsResources: { R11Data, R11Header }
    }
  } = useSelector((state: ApplicationState) => ({
    reports: state.reports
  }))

  const { t } = useTranslation()

  if (R11Data.loading || R11Header.loading) {
    return <Spin />
  }

  const active_users = R11Data.data?.[0]?.active_users
  const requests = R11Data.data?.[0]?.requests

  let ended_on: string = ''
  let started_on: string = ''
  let trade_name: string = ''

  if (R11Header.data?.[0]) {
    ended_on =
      moment.utc(R11Header.data[0].ended_on * 1000).format(format) || ''
    started_on =
      moment.utc(R11Header.data[0].started_on * 1000).format(format) || ''
    trade_name = R11Header.data[0].trade_name || ''
  }

  return (
    <>
      <OptionsBar />
      <CSSPage.WrapPage className="print" pageShape={A4_PORTRAIT}>
        <TitleReport title="web.report.11.title" />
        <CSS.Section>
          <div>
            <Typography.Text>
              <b>{t('web.organization.title')}: </b>
              {trade_name}
            </Typography.Text>
          </div>
          <div>
            <Typography.Text>
              <b>{t('web.reports.parameter.period.title')}: </b>
              {started_on} - {ended_on}
            </Typography.Text>
          </div>
        </CSS.Section>
        <CSS.Section>
          <div>
            <Typography.Text>
              <b>{t('web.report.11.total-users')}: </b>
              {active_users}
            </Typography.Text>
          </div>
          <div>
            <Typography.Text>
              <b>{t('web.report.11.total-requests')}: </b>
              {requests}
            </Typography.Text>
          </div>
        </CSS.Section>
      </CSSPage.WrapPage>
    </>
  )
}
